import { useLocation } from "react-router-dom";

function useQuery() { //' because it's hook we need to use "use" keyword - all React hooks should start with use
    return new URLSearchParams(useLocation().search);
}

export default useQuery;